import React, { Fragment } from 'react';
import CloseThemesModalButton from './CloseThemesModalButton';
import Loading from '../../components/Loading';
import EditableButtons from './EditableButtons';

import config from '../../config';

const Slide = ({ data, closeSliderModal, editable, cover_images }) => {
  const {
    name,
    text,
    habitat,
    local_name,
    scientific_name,
    altitude,
    duration,
    banner_images,
  } = data;
  const imageUrl = cover_images
    ? `${config.RESOURCE_URL}/${cover_images.large}`
    : banner_images
    ? `${config.RESOURCE_URL}/${banner_images.small}`
    : '';
  if (!text)
    return (
      <div className="slider-alt child-slide">
        <div className="slide-head">
          <h4>
            <i className="icon icon-hg-binoculars" /> {name}
          </h4>
          <CloseThemesModalButton close={closeSliderModal} />
        </div>
        <div className="slide-body">
          <Loading size="full" />
        </div>
      </div>
    );
  return (
    <Fragment>
      <div className="slider-alt child-slide">
        <div className="slide-head">
          <h4>
            <i className="icon icon-hg-binoculars" /> {name}
          </h4>
          <CloseThemesModalButton close={closeSliderModal} />
        </div>
        <div className="slide-body">
          <picture>
            <source srcSet={imageUrl} media="(max-width: 767px)" />
            <img alt={name} src={imageUrl} />
          </picture>
        </div>
        <div className="slide-foot">
          <p>{text}</p>
          <div className="other-detail">
            <ul>
              {local_name && (
                <li>
                  <span>Local Name:</span> {local_name}
                </li>
              )}
              {scientific_name && (
                <li>
                  <span>Scientific Name:</span> {scientific_name}
                </li>
              )}
              {habitat && (
                <li>
                  <span>Habitat:</span> {habitat}
                </li>
              )}
              {altitude && (
                <li>
                  <span>Altitude:</span> {altitude.meters.toLocaleString()} m
                </li>
              )}
              {duration && (
                <li>
                  <span>No. of Hours: </span> {duration}
                </li>
              )}
            </ul>
          </div>
          {editable && (
            <EditableButtons editable={editable} data={data} modalType="trekDayEdit" />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Slide;



// WEBPACK FOOTER //
// ./src/screens/Places/Slide.jsx